import {tsvParse} from "d3-dsv";
import dsv from "./dsv";

export default dsv("text/tab-separated-values", tsvParse);



//////////////////
// WEBPACK FOOTER
// ./~/d3-request/src/tsv.js
// module id = 784
// module chunks = 0